import { render, staticRenderFns } from "./saleCategoryForm.vue?vue&type=template&id=4676d804&"
import script from "./saleCategoryForm.vue?vue&type=script&lang=js&"
export * from "./saleCategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports